import { cn } from '@/lib/utils'

const base = cn(
    'inline-flex items-center justify-center gap-3 rounded-[3px] px-7 py-3.5 text-[0.95rem] font-medium',
    'transition-[background-color,color,border-color] duration-500 ease-paper',
    'focus-visible:outline-2 focus-visible:outline-offset-3 focus-visible:outline-bark',
    'disabled:cursor-not-allowed disabled:opacity-55'
)

// Pomegranate, the site's one accent, for the main action in a view
export const primaryButton = cn(base, 'bg-pomegranate text-paper hover:bg-pomegranate-deep')

// Same accent, kept as its own name for actions that complete a form
export const accentButton = primaryButton

// A quiet outline on paper
export const ghostButton = cn(base, 'border border-bark/30 text-bark hover:border-bark hover:bg-bark/[0.04]')

// Outline for the dark workshop band
export const ghostButtonOnDark = cn(base, 'border border-paper/40 text-paper hover:border-paper hover:bg-paper/10 focus-visible:outline-paper')
